import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ContactService } from './contact.service';
import { UtilityService } from 'lib/ng2-sapmp/src/providers';
@Component({
  selector: 'app-contact',
  providers: [ContactService],
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ContactComponent implements OnInit {

  phone: string;
  timeZone: string;

  constructor(
    private router: Router,
    private ContactService: ContactService,
    private utilityService: UtilityService
  ) {}

  ngOnInit() {
    this.ContactService.getContactDetails(this.utilityService.getEnvConfig().contactdetails)
        .subscribe(contactrespobj => {
          console.log(contactrespobj);
          this.phone = contactrespobj.phone_no;
          this.timeZone = contactrespobj.time;
        }, error => {
          this.handleError(error);
        });
  }

   handleError(error) {
    throw error;
  }
}
